export default "__VITE_ASSET__FfEdgg7c__"